import { ButtonHTMLAttributes } from 'react';

interface PresentationNavigationButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    testId: string;
}

export const PresentationNavigationButton = ({ testId, ...buttonProps }: PresentationNavigationButtonProps) => {
    const { children, className = '', type } = buttonProps;

    return (
        <button
            type={type}
            {...buttonProps}
            className={`hover:bg-primary p-0.25em pointer-events-auto transition-colors ease-in-out duration-200 ${className}`}
            data-testid={testId}
        >
            {children}
        </button>
    );
};
